var module = angular.module('octopusApp.infrastructure');

module.run(function ($rootScope) {
  $rootScope.isBound = function(value) {
    if (value) {
      return value.indexOf("#{") >= 0;
    }
    return true;
  };
});

module.factory('octoUtil', function() {
  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };

  return {
    escapeHtml: function (string) {
      return String(string).replace(/[&<>"'\/]/g, function (s) {
        return entityMap[s];
      });
    },
    toBoolean: function toBoolean(value) {
      if (value && value.length !== 0) {
        var v = angular.lowercase("" + value);
        value = !(v === 'f' || v === '0' || v === 'false' || v === 'no' || v === 'n' || v === '[]');
      } else {
        value = false;
      }
      return value;
    },

    insertString: function (source, index, string) {
      if (index > 0) {
        return source.substring(0, index) + string + source.substring(index, this.length);
      }
      else {
        return string + source;
      }
    },

    selectOptionsTextToList: function (input) {
      input = input || "";

      var lines = input.split("\n");
      var results = [];

      _.each(lines, function (l) {
        l = l.trim();
        if (l.length === 0) {
          return;
        }

        var parts = l.split('|');
        if (parts.length > 1) {
          results.push({
            Value: parts[0].trim(),
            DisplayText: parts[1].trim()
          });
        } else {
          results.push({
            Value: l,
            DisplayText: l
          });
        }
      });

      return results;
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/octo_util.js
// module id = 699
// module chunks = 1